import { __require as r } from "../bundled_deps/.pnpm/react@19.2.4/bundled_deps/react/compiler-runtime.js";
var i = r();
export {
  i as c
};
